<template>
	<div>
		<b-button type="is-primary" class="max-w-button highly-button" @click="$router.push({ name: 'coin-present-to-team', params: { teamId: id }})">
			<div class="horizontal-center-center button-icon-right">
				<span>このチームにコインを贈る</span><img :src="require('@/assets/icons/coin_big.svg')">
			</div>
		</b-button>

		<div class="image-area text-center mt-10">
			<avatar :image="image" :clickable="false" :isTeam="true" :width="312"></avatar>
			<div class="kana mt-20">{{ nameKana }}</div>
			<div class="bold18">{{ name }}</div>
			<div class="detail word-wrap mt-20">{{ detail }}</div>

			<div v-if="!isHidden">
				<div v-if="isEditable" class="action-button horizontal-center mt-20" style="width: 62px; margin-left: auto;" @click="$router.push({ name: 'team-edit', params: { teamId: id }})">
					<img :src="require('@/assets/icons/edit.svg')">
					<span>編集</span>
				</div>
			</div>
		</div>

		<div class="mt-30 mb-20 tm section-title">チームメンバー</div>

		<member-list-item
			class="member member-list-item mb-10"
			v-for="(row, index) in staffTeams"
			:key="index"
			:image="row.image"
			:name="row.name"
			:staffId="row.staff_id">

			<span v-if="!isEditable && row.is_organizer" class="organizer bold18">★主催者</span>
			<div v-if="!isHidden">
				<b-button v-if="isEditable && row.is_organizer && row.is_dissolve_show" rounded class="team-delete-button" @click="isModalActive = true">解散</b-button>
				<b-button v-if="isEditable && !row.is_organizer" rounded class="member-delete-button" @click="onMemberDeleteClick(index)">削除</b-button>
			</div>
		</member-list-item>

		<div v-if="isEditable && !isHidden">
			<div class="mt-30 mb-20 tm section-title">メンバーの追加</div>

			<div class="for-pc">
				<div class="mb-10 bold18 tm">所属</div>

				<b-select class="mb-15" v-model="teamId">
					<option value="">所属を選択する</option>
					<option
						v-for="row in teams"
						:value="row.id"
						:key="row.id">
						{{ row.name }}
					</option>
				</b-select>

				<div class="mb-10 bold18 tm">名前</div>

				<input type="text" class="sv-input mb-30" v-model="staffName"/>

				<b-button type="is-success" class="max-w-button mb-30 button-pc" :loading="isSearchLoading" @click="onSearchButtonClick">
					<div class="horizontal-center-center button-icon-right">
						<span>検索</span><img :src="require('@/assets/icons/search.svg')">
					</div>
				</b-button>

				<b-button type="is-primary" class="max-w-button mt-40 mb-40 button-pc" rounded :disabled="addStaffs.length === 0" @click="onMemberAddClick">メンバー追加</b-button>

				<div v-if="staffs.length > 0">
					<member-list-item
						class="member-list-item mb-10"
						v-for="(row, index) in staffs"
						:key="index"
						:image="row.image"
						:name="row.name"
						:staffId="row.id"
						>
			
						<b-checkbox v-model="addStaffs" size="is-medium" :native-value="row.id"></b-checkbox>
					</member-list-item>

					<b-button type="is-primary" class="max-w-button mt-40 button-pc" rounded :disabled="addStaffs.length === 0" @click="onMemberAddClick">メンバー追加</b-button>
				</div>
				<div v-else class="tm">{{ staffSearchResult }}</div>
			</div>
		</div>

		<b-modal :active.sync="isModalActive">
			<confirm-modal title="最終確認" body="本当にチームを解散しますか？実行すると元には戻せません。" okButtonTitle="実行" @ok-click="onModalOkClick" @cancel-click="isModalActive = false"></confirm-modal>
		</b-modal>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.member-list-item {
	.button {
		color: #fff;
		min-width: 60px;
		font-size: 14px;
		border: none;
	}
	.team-delete-button {
		background: $red;
	}
	.member-delete-button {
		background: $skyBlue;
	}
	/deep/ .right {
		padding-top: 12px !important;
	}
}

.image-area {
	background: #fff;
	margin-left: -$basePadding;
	margin-right: -$basePadding;
	padding: 30px 20px;

	.detail {
		font-size: 18px;
		text-align: left;
	}
}

@media screen and (min-width: $breakPoint) {
	$sideMargin: 120px;

	.member {
		margin-left: $sideMargin;
		margin-right: $sideMargin;
	}

	.for-pc {
		margin-left: $sideMargin;
		margin-right: $sideMargin;
	}

}

</style>

<script>
import Avatar from '@/components/Avatar'
import MemberListItem from '@/components/MemberListItem'
import ConfirmModal from '@/components/ConfirmModal'

export default {
	name: 'Team',
	components: {
		Avatar,
		MemberListItem,
		ConfirmModal,
	},
	data () {
		return {
			id: '',
			name: '',
			nameKana: '',
			image: '',
			detail: '',
			isHidden: false,
			isEditable: false,
			data: null,
			staffTeams: [],
			isModalActive: false,
			teamId: '',
			teams: [],
			isSearchLoading: false,
			staffs: [],
			staffName: '',
			staffSearchResult: '',
			addStaffs: [],
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	methods: {
		onMemberAddClick: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'staff-teams';
			this.$utils.log(ep);

			let data = {
				"team_id": this.id,
			};

			let st = [];
			for (let i in this.addStaffs) {
				st.push({
					"team_id": this.id,
					"staff_id": this.addStaffs[i],
				});
			}
			data.staff_teams = st;
			this.$utils.log(data);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
		onSearchButtonClick: async function() {
			this.staffSearchResult = '';
			this.isSearchLoading = true;

			let ep = `staffs/search-for-team-add?team_id=${this.teamId}&name=${this.staffName}&current_team_id=${this.id}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.staffs = res.data.staffs;
				if (this.staffs.length === 0) this.staffSearchResult = '見つかりませんでした';
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSearchLoading = false;
			}
		},
		onModalOkClick: async function() {
			this.$utils.log('onModalOkClick');
			this.isModalActive = false;

			let loader = this.$buefy.loading.open();
			let ep = 'teams/' + this.id;
			this.$utils.log(ep);

			try {
				let res = await this.$api.delete(ep, null, true);
				this.$utils.log(res);

				// 戻り先では復帰処理をOFFにしてデータ再読み込み
				this.$store.commit('disableCoinPresentDataRecovery');

				this.$router.push({ name: 'coin-present' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
		onMemberDeleteClick: async function(index) {
			this.$utils.log('onMemberDeleteClick id='+index);
			let loader = this.$buefy.loading.open();
			let ep = 'staff-teams/delete';
			this.$utils.log(ep);

			let data = {
				'team_id': this.id,
				'id' : this.staffTeams[index].id,
			};
			this.$utils.log(data);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.getData();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'teams/' + this.$route.params.teamId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.data = res.data;
				this.id = res.data.id;
				this.name = res.data.name;
				this.nameKana = res.data.name_kana;
				this.image = res.data.image;
				this.detail = res.data.detail;
				this.isHidden= res.data.is_hidden;
				this.isEditable = res.data.is_editable;
				this.staffTeams = res.data.staff_teams;
				this.teams = res.data.teams;
				this.staffs = [];
				this.addStaffs = [];
				this.teamId = '';
				this.staffName = '';
				this.onSearchButtonClick();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
